import  SearchBoxV2 from './component';
export { SearchBoxV2 };